// src/ui/PerlAutocomplete.jsx
import React from "react";
import { Autocomplete, TextField, alpha, useTheme, Box, Typography } from "@mui/material";

export default function PerlAutocomplete({
  label,
  value,
  onChange,
  options = [],
  placeholder = "Type to search...",
  disabled = false,
  size = "small",
  ...props
}) {
  const theme = useTheme();
  const perlColors = theme.custom?.perlColors;

  return (
    <Box>
      {label && (
        <Typography
          variant="body2"
          sx={{
            mb: 1,
            color: perlColors?.textSecondary || "#798286",
            fontWeight: 500,
          }}
        >
          {label}
        </Typography>
      )}
      <Autocomplete
        options={options}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        size={size}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            size={size}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        )}
        componentsProps={{
          paper: {
            sx: {
              bgcolor: perlColors?.surface || "#242728",
              "& .MuiAutocomplete-listbox": {
                "& .MuiAutocomplete-option": {
                  color: perlColors?.textPrimary,
                  "&:hover": {
                    bgcolor: alpha(perlColors?.white || "#FFFFFF", 0.08),
                  },
                  "&[aria-selected='true']": {
                    bgcolor: alpha(perlColors?.white || "#FFFFFF", 0.12),
                    "&:hover": {
                      bgcolor: alpha(perlColors?.white || "#FFFFFF", 0.16),
                    },
                  },
                },
              },
              "& .MuiAutocomplete-noOptions": {
                color: perlColors?.textPrimary,
              },
            },
          },
        }}
        {...props}
      />
    </Box>
  );
}
